module.exports = __webpack_public_path__ + "static/media/143.bf6db125.jpg";